<mat-stepper orientation="vertical" [@fadeIn] [@.disabled]="!fade" linear labelPosition="bottom" #stepper
    [selectedIndex]="currentArrayIndex" data-test-id="navigation-bar">
    <ng-container *ngFor="let elem of elements; let i = index">
        <mat-step *ngIf="i === currentArrayIndex" [completed]="i === currentArrayIndex" [editable]="false">
            <ng-template matStepLabel active>{{elem.text}}</ng-template>
        </mat-step>
        <mat-step *ngIf="i !== currentArrayIndex" [completed]="i < currentArrayIndex" [editable]="false">
            <ng-template matStepLabel>{{elem.text}}</ng-template>
        </mat-step>
    </ng-container>
</mat-stepper>